// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-kbd {
  font-family: "Roboto", sans-serif;
  align-items: center;
  align-self: stretch;
  background: rgb(var(--v-theme-kbd));
  color: rgb(var(--v-theme-on-kbd));
  display: inline-flex;
  font-size: 0.875em;
  font-weight: normal;
  line-height: 1;
  justify-content: center;
  min-height: 1em;
  min-width: 20px;
  padding: 3px 6px;
  vertical-align: baseline;
  margin-inline: 1px;
}
:where(.vuetify-styles) .v-kbd {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: thin;
}
:where(.vuetify-styles) .v-kbd--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-kbd {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-kbd {
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VKbd/VKbd.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".v-kbd {\n  font-family: \"Roboto\", sans-serif;\n  align-items: center;\n  align-self: stretch;\n  background: rgb(var(--v-theme-kbd));\n  color: rgb(var(--v-theme-on-kbd));\n  display: inline-flex;\n  font-size: 0.875em;\n  font-weight: normal;\n  line-height: 1;\n  justify-content: center;\n  min-height: 1em;\n  min-width: 20px;\n  padding: 3px 6px;\n  vertical-align: baseline;\n  margin-inline: 1px;\n}\n.v-kbd {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: thin;\n}\n.v-kbd--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-kbd {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-kbd {\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
